module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"city":"Мой город","citySaved":"Новый город сохранен.","change":"Изменить","errors":{"city":{"required":"Обязательно выберите город"}}}}')
  delete Component.options._Ctor
}
